import { twMerge } from 'tailwind-merge'

type Props = {
  className?: string
  show?: boolean
} & React.ComponentPropsWithoutRef<'div'>

export default function Loading({ className, show }: Props) {
  return (
    <div
      className={twMerge(
        'flex justify-center items-center px-8 pb-8 transition ml-0 lg:ml-80',
        'fixed backdrop-blur-md top-0 left-0 right-0 bottom-0 z-30',
        className,
        show ? 'flex' : 'hidden',
      )}
    >
      <svg className='animate-spin w-16 text-zinc-800' xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24'>
        <title>Loading</title>
        <circle className='opacity-25' cx='12' cy='12' r='10' stroke='currentColor' strokeWidth='4'></circle>
        <path
          fill='currentColor'
          d='M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z'
        ></path>
      </svg>
    </div>
  )
}
